var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminTutorRejectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6221",
    "data-name": "Group 6221",
    transform: "translate(-150 -425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4802",
    "data-name": "Group 4802",
    transform: "translate(-162 413.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3991",
    "data-name": "Group 3991",
    transform: "translate(312 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(0 -0.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 42,
    height: 42,
    rx: 21,
    fill: "#ff0909"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4805",
    "data-name": "Group 4805",
    transform: "translate(158.669 433.668)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 1.031,
    cy: 1.031,
    r: 1.031,
    transform: "translate(13.362 18.516) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4101",
    "data-name": "Path 4101",
    d: "M11.558,14.393a.773.773,0,1,0,1.546,0ZM13.1,7.177a.773.773,0,1,0-1.546,0Zm8.762,5.154a9.535,9.535,0,0,1-9.535,9.535v1.546A11.081,11.081,0,0,0,23.412,12.331Zm-9.535,9.535A9.535,9.535,0,0,1,2.8,12.331H1.25A11.081,11.081,0,0,0,12.331,23.412ZM2.8,12.331A9.535,9.535,0,0,1,12.331,2.8V1.25A11.081,11.081,0,0,0,1.25,12.331ZM12.331,2.8a9.535,9.535,0,0,1,9.535,9.535h1.546A11.081,11.081,0,0,0,12.331,1.25Zm.773,11.6V7.177H11.558v7.216Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminTutorRejectedIcon);
export default __webpack_public_path__ + "static/media/admin-tutor-rejected-icon.819835729f959e914938c39f9c8ea0a3.svg";
export { ForwardRef as ReactComponent };